export default class VontobelChosen {
  init(context) {
    const selects = jQuery('select.chosen-manually:not(.chosen-bound)', context);

    if (selects.length === 0) {
      return;
    }

    selects.on('chosen:ready', function (event) {
      jQuery(event.target).addClass('chosen-bound');
    });

    selects.chosen(drupalSettings.chosen ? drupalSettings.chosen.options : null);
  }
}
